import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Career from "./pages/Career";
import Institution from "./pages/Institution";
import ProjeDetay from "./pages/ProjeDetay";
import MaintenancePage from "./pages/Maintenance"; // Yeni eklenen sayfa

function App() {
    const [isMaintenance, setIsMaintenance] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch("/config.json")
            .then((res) => res.json())
            .then((data) => {
                setIsMaintenance(data.maintenance);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Config yüklenemedi:", err);
                setLoading(false); // Hata durumunda normal siteyi göster
            });
    }, []);

    if (loading) return null; // veya bir loading ekranı gösterebilirsin

    if (isMaintenance) {
        return <MaintenancePage />;
    }

    return (
        <div className="App">
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/hakkimizda" element={<About />} />
                <Route path="/cozumlerimiz/:slug" element={<ProjeDetay />} />
                <Route path="/iletisim" element={<Contact />} />
                <Route path="/kariyer" element={<Career />} />
                <Route path="/kurumlar" element={<Institution />} />
            </Routes>
            <Footer />
        </div>
    );
}

export default App;
